import { Button } from '@/components/ui/button'
import { Drawer, DrawerContent, DrawerOverlay } from '@/components/ui/drawer'
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from '@/components/ui/dropdown-menu'
import { addEventToCache, emitEventRemoved, removeEventFromCache } from '@/services/client.service'
import { HugeiconsIcon } from '@hugeicons/react'
import { SaveIcon, Delete01Icon } from '@hugeicons/core-free-icons'
import { Event } from '@nostr/tools/wasm'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function LocalDatabaseMenuButton({
  event,
  is,
  mode,
  onAction
}: {
  event: Event
  is: boolean
  mode: 'drawer' | 'dropdown'
  onAction?: () => void
}) {
  const { t } = useTranslation()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const menuItems = (
    <>
      {!is && (
        <DropdownMenuItem
          onClick={() => {
            addEventToCache(event)
            onAction?.()
          }}
        >
          <HugeiconsIcon icon={SaveIcon} className="!w-4 !h-4" /> {t('Save')}
        </DropdownMenuItem>
      )}
      {is && (
        <DropdownMenuItem
          onClick={() => {
            removeEventFromCache(event.id)
            emitEventRemoved(event.id)
            onAction?.()
          }}
        >
          <HugeiconsIcon icon={Delete01Icon} className="!w-4 !h-4" /> {t('Delete')}
        </DropdownMenuItem>
      )}
    </>
  )

  if (mode === 'dropdown') {
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger className="min-w-52 cursor-pointer">
          <HugeiconsIcon icon={SaveIcon} className="!w-6 !h-6" /> {t('Local Database')}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent>{menuItems}</DropdownMenuSubContent>
      </DropdownMenuSub>
    )
  }

  return (
    <>
      <Button
        className="w-full p-6 justify-start text-lg gap-4 cursor-pointer"
        variant="ghost"
        onClick={() => setIsDrawerOpen(true)}
      >
        <HugeiconsIcon icon={SaveIcon} className="!w-6 !h-6" /> {t('Local Database')}
      </Button>
      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerOverlay className="bg-black/20" onClick={() => setIsDrawerOpen(false)} />
        <DrawerContent>
          <div className="py-2">
            {!is && (
              <Button
                className="w-full p-6 justify-start text-lg gap-4"
                variant="ghost"
                onClick={() => {
                  addEventToCache(event)
                  setIsDrawerOpen(false)
                  onAction?.()
                }}
              >
                <HugeiconsIcon icon={SaveIcon} className="!w-4 !h-4" /> {t('Save')}
              </Button>
            )}
            {is && (
              <Button
                className="w-full p-6 justify-start text-lg gap-4"
                variant="ghost"
                onClick={() => {
                  removeEventFromCache(event.id)
                  emitEventRemoved(event.id)
                  setIsDrawerOpen(false)
                  onAction?.()
                }}
              >
                <HugeiconsIcon icon={Delete01Icon} className="!w-4 !h-4" /> {t('Delete')}
              </Button>
            )}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  )
}
